import * as axios from "axios";
import { getAuthHeader, getUploadFileHeader, removeAllCookies } from "../utils";

export const AddCircular = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}circular-list/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const AddCircularAttachment = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}add-circular-attachments`;
  return axios.post(url, model, getUploadFileHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const CircularFileByAdmin = (page = 1) => {
  const url = `${process.env.REACT_APP_BASE_URL}circular-list/by-admin/${page}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const CircularByCorporate = (page = 1, keyword = '', department = '', fromDate = '', toDate = '') => {
  let url = `${process.env.REACT_APP_BASE_URL}circular-list/by-corporate/${page}`;
  
  // Build query parameters
  const params = new URLSearchParams();
  
  if (keyword && keyword.trim() !== '') {
    params.append('keyword', keyword);
  }
  
  if (department && department.toString().trim() !== '') {
    params.append('department', department);
  }
  
  if (fromDate && fromDate.trim() !== '') {
    params.append('fromDate', fromDate);
  }
  
  if (toDate && toDate.trim() !== '') {
    params.append('toDate', toDate);
  }
  
  // Add query string if there are any parameters
  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }
  
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};
export const getSearchResult = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}search-filter/circular`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const getSearchResultForCorporate = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}search-filter/circular/corporate`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const CircularFileForAll = (page = 1, keyword = '', department = '', fromDate = '', toDate = '') => {
  let url = `${process.env.REACT_APP_BASE_URL}circular-list/for-all/${page}`;
  
  // Build query parameters
  const params = new URLSearchParams();
  
  if (keyword && keyword.trim() !== '') {
    params.append('keyword', keyword);
  }
  
  if (department && department.toString().trim() !== '') {
    params.append('department', department);
  }
  
  if (fromDate && fromDate.trim() !== '') {
    params.append('fromDate', fromDate);
  }
  
  if (toDate && toDate.trim() !== '') {
    params.append('toDate', toDate);
  }
  
  // Add query string if there are any parameters
  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }
  
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};
export const getFileStatus = (fileCode) => {
  const url = `${process.env.REACT_APP_BASE_URL}check-file-status?fileCode=${fileCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const getAccessList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}get-access-user-list`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.response.data.error);

      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const searchWithKeywords = (keyword, searchType) => {
  const url = `${process.env.REACT_APP_BASE_URL}get-circular-file/by-keyword?q=${keyword}&searchType=${searchType}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};

export const CircularFileDetails = (fileCode) => {
  const url = `${process.env.REACT_APP_BASE_URL}get-circular-file/details/${fileCode}`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};
